import { motion } from "framer-motion";
import { BookOpen, HeartHandshake, Sprout, Users } from "lucide-react";

const STRANDS = [
  { icon: BookOpen, word: "Learning", line: "Lifelong, curious and shared — at every age.", color: "text-primary" },
  { icon: HeartHandshake, word: "Healing", line: "Care for body, mind and spirit as part of growth.", color: "text-bloom" },
  { icon: Sprout, word: "Becoming", line: "Room to grow into who you are, rooted like a seed.", color: "text-leaf" },
  { icon: Users, word: "Contribution", line: "What we learn and heal flows back into community.", color: "text-gold" },
];

export const Story = ({ headingAs: Heading = "h2" }) => (
  <section id="story" className="relative bg-muted/60 py-28 lg:py-36" data-testid="story-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-primary">Our story &amp; philosophy</p>
          <Heading className="mt-6 font-display text-4xl font-bold leading-tight tracking-tight text-foreground sm:text-5xl">
            Not a school. <span className="text-primary">An ecology.</span>
          </Heading>
        </div>
        <div className="space-y-6 text-base leading-relaxed text-foreground/80 sm:text-lg lg:col-span-7">
          <p>
            In nature nothing grows alone. Roots, leaves and flowers feed one another. Nia Ecoversity works the same way:
            learning, healing, becoming and contribution are not four separate programmes, but four parts of one living whole.
          </p>
          <p className="border-l-4 border-primary pl-6 font-display text-2xl font-medium text-foreground sm:text-3xl" data-testid="story-quote">
            "We treat learning, healing and contribution as one journey, not separate things."
          </p>
        </div>
      </div>
      <div className="mt-20 grid gap-px border border-border bg-border sm:grid-cols-2 lg:grid-cols-4">
        {STRANDS.map((s, i) => (
          <motion.div key={s.word} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.7, delay: i * 0.1 }}
            className="bg-card p-10 transition-colors duration-300 hover:bg-muted"
            data-testid={`strand-${s.word.toLowerCase()}`}>
            <s.icon className={`h-7 w-7 ${s.color}`} strokeWidth={1.5} />
            <h3 className="mt-6 font-display text-3xl font-bold text-foreground">{s.word}</h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground/70">{s.line}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
